import React, { useState, useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import { LangLink } from "../../../utils/langNavigation";
import NotFound from "../../../pages/notfound/NotFound";
import "./detail.scss";
import Overview from "./tabs/overview"; // Import the Overview component
import Header from "./header"; // Import the Header component
import AffectedProducts from "./tabs/affected_products"; // Import the AffectedProducts component
import Remediation from "./tabs/remediation"; // Import the Remediation component
import RevisionHistory from "./tabs/revision_history"; // Import the RevisionHistory component
import {
  Layout,
  Breadcrumbs,
  Notification,
} from "@netapp/bxp-design-system-react/";
import axios from "axios";
import { useTranslation } from "react-i18next";

const Details = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const adv_id = pathname.split("/advisory/")[1];
  const { advisoryId } = useParams();
  const location = useLocation();
  const baseUrl = window.location.origin.replace(/\/advisory$/, "");
  const { ntap_advisory_id, advisory } = location.state || {
    ntap_advisory_id: adv_id.toUpperCase(),
    advisory: "Details Page",
  };
  const [notification, setNotification] = useState({
    visible: false,
    message: "",
    type: "success",
  });

  const [currentTab, setCurrentTab] = useState(1);
  const [advisoryData, setAdvisoryData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  // Fetch the advisory details only once
  useEffect(() => {
    const fetchAdvisory = async () => {
      try {
        const response = await axios.get(
          // `${baseUrl}/api/advisories/${adv_id}`
          `${process.env.REACT_APP_API_BASE_URL}/advisory/${adv_id}`
        );
        if (response.data.advisory) {
          setAdvisoryData(response.data.advisory);
        } else {
          setNotFound(true);
        }
      } catch (error) {
        console.error("Error fetching advisory details:", error);
        setNotFound(true);
      } finally {
        setLoading(false);
      }
    };

    fetchAdvisory();
  }, [advisoryId]);

  if (notFound) {
    return <NotFound />;
  }

  return (
    <div className="detail-outer-frame">
      {notification.visible && (
        <Notification type={notification.type}>{notification.message}</Notification>
      )}
      <div className="detail-inner-frame">
        <Layout.Page>
          <Layout.Content>
            <Layout.BreadcrumbsContainer className="breadcrumb-container">
              <Breadcrumbs>
                <LangLink to="/">{t("securityPortal.other")}</LangLink>
                <LangLink to="/advisory">{t("security_advisories.other")}</LangLink>
                <div className="breadcrumb-active">{ntap_advisory_id}</div>
              </Breadcrumbs>
            </Layout.BreadcrumbsContainer>
            <div className="details-page">
              <Header
                advisory={ntap_advisory_id}
                advisoryData={advisoryData}
                cve={advisoryData?.cve}
                currentTab={currentTab}
                setCurrentTab={setCurrentTab}
                advisoryId={advisoryId}
                notification={notification}
                setNotification={setNotification}
              />
            </div>

            {currentTab === 1 && (
              <Overview advisoryData={advisoryData} loading={loading} />
            )}
            {currentTab === 2 && (
              <AffectedProducts advisoryData={advisoryData} loading={loading} />
            )}
            {currentTab === 3 && (
              <Remediation advisoryData={advisoryData} loading={loading} />
            )}
            {currentTab === 4 && (
              <RevisionHistory advisoryData={advisoryData} loading={loading} />
            )}
          </Layout.Content>
        </Layout.Page>
      </div>
    </div>
  );
};

export default Details;
